

// import React, { useState, useEffect } from 'react';

// import '../styles/AddEmployee.css'

// const AddEmployee = () => {
//   const [formData, setFormData] = useState({
//     employeeCode: '',
//     firstName: '',
//     lastName: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     gender: '',
//     department: '',
//     designation: '',
//     city: '',
//     mobile: '',
//     birthdate: '',
//     joiningDate: '',    // added 
//     address: '',
//     country: '',
//     role: 'Employee'
//   });

//   const [departments, setDepartments] = useState([]);
//   const [isGenesisCompany, setIsGenesisCompany] = useState(false);
//   const genesisDepartments = [
//     "GTE-Human Resource",
//     "GTE-Technology Operations",
//     "GTE-Accounts",
//     "GTE-Admin",
//     "FI Design",
//     "FSPLO",
//     "LTDM PC",
//     "DDI",
//     "DMS",
//     "FI-IE",
//     "LTO"
//   ];

//   const genesisDesignations = [
//     "Electrical Design Engineer",
//     "Mechanical Design Engineer",
//     "Civil/Structural Design Engineer (BIM)",
//     "BIM Modeler",
//     "Technical Project Coordinator (Power BI)",
//     "Project Coordinator",
//     "Software Development Engineer",
//     "HR Associate",
//     "Accountant",
//     "Peon"
//   ];

// useEffect(() => {
//   fetch("/gt-api/get_departments.php", {
//     credentials: "include"
//   })
//     .then(res => res.json())
//     .then(data => {
//         console.log("FULL RESPONSE:", data);
//       if (data.success) {
//         setDepartments(data.departments || []);
//         console.log("TENANT:", data.tenant);

//         setIsGenesisCompany(data.tenant === "elmsdb");
//       }
//     })
//     .catch(err => console.error(err));
// }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const calculateProgress = () => {
//     const filled = Object.values(formData).filter(v => v !== '').length;
//     return (filled / 15) * 100;
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirmPassword) {
//       alert("Passwords do not match!");
//       return;
//     }

//     const submitData = {
//       empId: formData.employeeCode,
//       firstName: formData.firstName,
//       lastName: formData.lastName,
//       email: formData.email,
//       password: formData.password,
//       gender: formData.gender,
//       dob: formData.birthdate,
//       joiningDate: formData.joiningDate,
//       department: formData.department,
//       designation: formData.designation,
//       mobile: formData.mobile,
//       role: formData.role,
//       city: formData.city,
//       country: formData.country,
//       address: formData.address
//     };

//     try {
//       const response = await fetch("/gt-api/add_employee.php", {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const result = await response.json();
//       if (result.success) {
//         alert("Employee Onboarded Successfully!");
//         // Optional: Reset form or redirect
//       } else {
//         alert("Error: " + result.message);
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("System Offline: Could not reach the PHP server. Check XAMPP.");
//     }
//   };


//   return (
//     <div className="genesis-onboarding-hub animate-fade">

//       <div className="ambient-glow"></div>

//       <div className="hub-layout">
//         <div className="interface-panel">
//           <div className="panel-header">
//             <div className="header-status-indicator">
//               <div className="pulse-dot"></div>
//               {/* <span>SYSTEM_ACTIVE</span> */}
//             </div>
//             <h3 className="glitch-text" data-text="Personnel Onboarding">Personnel Onboarding</h3>
//           </div>

//           <form className="interactive-sequencer" onSubmit={handleSubmit}>
//             <div className="sequencer-grid">

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label >EMPLOYEE_ID</label>
//                   <input type="text" name="employeeCode" placeholder="GTE-2026-X" onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>ASSIGN_ROLE</label>
//                   <select name="role" value={formData.role} onChange={handleChange}>
//                     <option value="Employee">Employee</option>
//                     <option value="Management">Management</option>
//                     <option value="Manager">Manager</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>FIRST_NAME</label>
//                   <input type="text" name="firstName" placeholder="First Name" onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>LAST_NAME</label>
//                   <input type="text" name="lastName" placeholder="Last Name" onChange={handleChange} required />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>EMAIL_ADDRESS</label>
//                 <input type="email" name="email" placeholder="official@genesistech.com" onChange={handleChange} required />
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>PASSWORD</label>
//                   <input type="password" name="password" placeholder="••••••••" onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>CONFIRM_PASSWORD</label>
//                   <input type="password" name="confirmPassword" placeholder="••••••••" onChange={handleChange} required />
//                 </div>
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>GENDER</label>
//                   <select name="gender" onChange={handleChange} required>
//                     <option value="">Select...</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </select>
//                 </div>
//                 {/* <div className="seq-group">
//                   <label>BIRTH_DATE</label>
//                   <input type="date" name="birthdate" onChange={handleChange} required />
//                 </div> */}
//                 <div className="seq-group">
//                   <label>BIRTH_DATE</label>
//                   <input
//                     type="date"
//                     name="birthdate"
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="seq-group">
//                   <label>JOINING_DATE</label>
//                   <input
//                     type="date"
//                     name="joiningDate"
//                     onChange={handleChange}
//                     required
//                     className="highlight-input"
//                   />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>DEPARTMENT</label>

//                 <select
//                   name="department"
//                   value={formData.department}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Department...</option>

//                   {isGenesisCompany
//                     ? genesisDepartments.map((dept) => (
//                       <option key={dept} value={dept}>
//                         {dept}
//                       </option>
//                     ))
//                     : departments.map((dept) => (
//                       <option key={dept.id} value={dept.DepartmentName}>
//                         {dept.DepartmentName}
//                       </option>
//                     ))}
//                 </select>
//               </div>
            
//               <div className="seq-group full">
              
//                 <label>DESIGNATION</label>

//                 {isGenesisCompany ? (
//                   <select
//                     name="designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">Select Designation...</option>

//                     {genesisDesignations.map((desg) => (
//                       <option key={desg} value={desg}>
//                         {desg}
//                       </option>
//                     ))}
//                   </select>
//                 ) : (
//                   <input
//                     type="text"
//                     name="designation"
//                     placeholder="Enter Designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                     required
//                   />
//                 )}
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>CITY</label>
//                   <input type="text" name="city" placeholder="City" onChange={handleChange} />
//                 </div>
//                 <div className="seq-group">
//                   <label>COUNTRY</label>
//                   <input type="text" name="country" placeholder="Country" onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>MOBILE_NO</label>
//                 <input type="text" name="mobile" placeholder="+XX XXXXX-XXXXX" onChange={handleChange} />
//               </div>

//               <div className="seq-group full">
//                 <button type="submit" className="initialize-btn">
//                   ADD EMPLOYEE
//                   <div className="btn-glow"></div>
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="neural-preview-panel">
//           <div className="radial-status-container">
//             <svg className="radial-svg" viewBox="0 0 100 100">
//               <circle className="bg" cx="50" cy="50" r="45" />
//               <circle
//                 className="meter"
//                 cx="50" cy="50" r="45"
//                 style={{ strokeDashoffset: 282 - (282 * calculateProgress()) / 100 }}
//               />
//             </svg>
//             <div className="radial-info">
//               <span className="percent">{Math.round(calculateProgress())}%</span>
//               <span className="label">SYNCED</span>
//             </div>
//           </div>

//           <div className="glass-id-card">
//             <div className="card-glare"></div>
//             <div className="card-header">
//               <span className="genesis-chip"></span>
//               <span className="card-title">GENESIS_ID</span>
//             </div>
//             <div className="bio-avatar-wrapper">
//               <div className="bio-avatar">
//                 {formData.firstName.charAt(0) || 'G'}
//               </div>
//             </div>
//             <div className="bio-data">
//               <h4>{formData.firstName || 'NEW'} {formData.lastName || 'USER'}</h4>
//               <p className="cyan-text">{formData.department || 'PENDING_SECTOR'}</p>
//               <div className="data-bits">
//                 <div className="bit"><span>UID:</span> {formData.employeeCode || 'AWAITING'}</div>
//                 <div className="bit"><span>ROLE:</span> {formData.role.toUpperCase()}</div>
//                 <div className="bit"><span>LOC:</span> {formData.city || 'PENDING'}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddEmployee;


















// import React, { useState, useEffect } from 'react';

// import '../styles/AddEmployee.css'

// const initialFormState = {
//   employeeCode: '',
//   firstName: '',
//   lastName: '',
//   email: '',
//   password: '',
//   confirmPassword: '',
//   gender: '',
//   department: '',
//   designation: '',
//   city: '',
//   mobile: '',
//   birthdate: '',
//   joiningDate: '',
//   address: '',
//   country: '',
//   role: ''
// };

// const AddEmployee = () => {
//   const [formData, setFormData] = useState(initialFormState);
//   const [successBanner, setSuccessBanner] = useState('');

//   const [departments, setDepartments] = useState([]);
//   const [isGenesisCompany, setIsGenesisCompany] = useState(false);
//   const genesisDepartments = [
//     "GTE-Human Resource",
//     "GTE-Technology Operations",
//     "GTE-Accounts",
//     "GTE-Admin",
//     "FI Design",
//     "FSPLO",
//     "LTDM PC",
//     "DDI",
//     "DMS",
//     "FI-IE",
//     "LTO"
//   ];

//   const genesisDesignations = [
//     "Electrical Design Engineer",
//     "Mechanical Design Engineer",
//     "Civil/Structural Design Engineer (BIM)",
//     "BIM Modeler",
//     "Technical Project Coordinator (Power BI)",
//     "Project Coordinator",
//     "Software Development Engineer",
//     "HR Associate",
//     "Accountant",
//     "Peon"
//   ];

//   useEffect(() => {
//     fetch("/gt-api/get_departments.php", {
//       credentials: "include"
//     })
//       .then(res => res.json())
//       .then(data => {
//         console.log("FULL RESPONSE:", data);
//         if (data.success) {
//           setDepartments(data.departments || []);
//           console.log("TENANT:", data.tenant);

//           setIsGenesisCompany(data.tenant === "elmsdb");
//         }
//       })
//       .catch(err => console.error(err));
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     if (successBanner) setSuccessBanner('');
//   };

//   const calculateProgress = () => {
//     const filled = Object.values(formData).filter(v => v !== '').length;
//     return (filled / 15) * 100;
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSuccessBanner('');

//     if (formData.password !== formData.confirmPassword) {
//       alert("Passwords do not match!");
//       return;
//     }

//     const submitData = {
//       empId: formData.employeeCode,
//       firstName: formData.firstName,
//       lastName: formData.lastName,
//       email: formData.email,
//       password: formData.password,
//       gender: formData.gender,
//       dob: formData.birthdate,
//       joiningDate: formData.joiningDate,
//       department: formData.department,
//       designation: formData.designation,
//       mobile: formData.mobile,
//       role: formData.role,
//       city: formData.city,
//       country: formData.country,
//       address: formData.address
//     };

//     try {
//       const response = await fetch("/gt-api/add_employee.php", {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const result = await response.json();
//       if (result.success) {
//         setFormData(initialFormState);
//         setSuccessBanner("🎉 Employee onboarded successfully! Form cleared.");
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//       } else {
//         alert("Error: " + result.message);
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("System Offline: Could not reach the PHP server. Check XAMPP.");
//     }
//   };


//   return (
//     <div className="genesis-onboarding-hub animate-fade">

//       <div className="ambient-glow"></div>

//       <div className="hub-layout">
//         <div className="interface-panel">
//           <div className="panel-header">
//             <div className="header-status-indicator">
//               <div className="pulse-dot"></div>
//               {/* <span>SYSTEM_ACTIVE</span> */}
//             </div>
//             <h3 className="glitch-text" data-text="Personnel Onboarding">Personnel Onboarding</h3>
//           </div>

//           {successBanner && (
//             <div className="add-emp-success-banner">
//               <div className="banner-content">
//                 <span className="banner-icon">✅</span>
//                 <span>{successBanner}</span>
//               </div>
//               <button
//                 type="button"
//                 className="banner-close-btn"
//                 onClick={() => setSuccessBanner('')}
//               >
//                 ✕
//               </button>
//             </div>
//           )}

//           <form className="interactive-sequencer" onSubmit={handleSubmit}>
//             <div className="sequencer-grid">

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label >EMPLOYEE_ID</label>
//                   <input type="text" name="employeeCode" placeholder="GTE-2026-X" value={formData.employeeCode} onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>ASSIGN_ROLE</label>
//                   <select name="role" value={formData.role} onChange={handleChange} required>
//                     <option value="" disabled hidden>Select Role...</option>
//                     <option value="Employee">Employee</option>
//                     <option value="Management">Management</option>
//                     <option value="Manager">Manager</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>FIRST_NAME</label>
//                   <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>LAST_NAME</label>
//                   <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>EMAIL_ADDRESS</label>
//                 <input type="email" name="email" placeholder="official@genesistech.com" value={formData.email} onChange={handleChange} required />
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>PASSWORD</label>
//                   <input type="password" name="password" placeholder="••••••••" value={formData.password} onChange={handleChange} required />
//                 </div>
//                 <div className="seq-group">
//                   <label>CONFIRM_PASSWORD</label>
//                   <input type="password" name="confirmPassword" placeholder="••••••••" value={formData.confirmPassword} onChange={handleChange} required />
//                 </div>
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>GENDER</label>
//                   <select name="gender" value={formData.gender} onChange={handleChange} required>
//                     <option value="">Select...</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </select>
//                 </div>
//                 <div className="seq-group">
//                   <label>BIRTH_DATE</label>
//                   <div className="add-emp-date-wrapper">
//                     <input
//                       type="date"
//                       name="birthdate"
//                       value={formData.birthdate || ""}
//                       onChange={handleChange}
//                       onClick={(e) => {
//                         try {
//                           if (e.target.showPicker) e.target.showPicker();
//                         } catch (err) {}
//                       }}
//                       className="add-emp-date-input"
//                     />
//                     <button
//                       type="button"
//                       className="add-emp-calendar-btn"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         const input = e.currentTarget.previousElementSibling;
//                         if (input) {
//                           try {
//                             if (input.showPicker) input.showPicker();
//                             else input.focus();
//                           } catch (err) {
//                             input.focus();
//                           }
//                         }
//                       }}
//                       title="Open Calendar"
//                     >
//                       <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//                         <line x1="16" y1="2" x2="16" y2="6"></line>
//                         <line x1="8" y1="2" x2="8" y2="6"></line>
//                         <line x1="3" y1="10" x2="21" y2="10"></line>
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//                 <div className="seq-group">
//                   <label>JOINING_DATE</label>
//                   <div className="add-emp-date-wrapper">
//                     <input
//                       type="date"
//                       name="joiningDate"
//                       value={formData.joiningDate || ""}
//                       onChange={handleChange}
//                       onClick={(e) => {
//                         try {
//                           if (e.target.showPicker) e.target.showPicker();
//                         } catch (err) {}
//                       }}
//                       required
//                       className="add-emp-date-input highlight-input"
//                     />
//                     <button
//                       type="button"
//                       className="add-emp-calendar-btn"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         const input = e.currentTarget.previousElementSibling;
//                         if (input) {
//                           try {
//                             if (input.showPicker) input.showPicker();
//                             else input.focus();
//                           } catch (err) {
//                             input.focus();
//                           }
//                         }
//                       }}
//                       title="Open Calendar"
//                     >
//                       <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                         <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//                         <line x1="16" y1="2" x2="16" y2="6"></line>
//                         <line x1="8" y1="2" x2="8" y2="6"></line>
//                         <line x1="3" y1="10" x2="21" y2="10"></line>
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>DEPARTMENT</label>

//                 <select
//                   name="department"
//                   value={formData.department}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Department...</option>

//                   {isGenesisCompany
//                     ? genesisDepartments.map((dept) => (
//                       <option key={dept} value={dept}>
//                         {dept}
//                       </option>
//                     ))
//                     : departments.map((dept) => (
//                       <option key={dept.id} value={dept.DepartmentName}>
//                         {dept.DepartmentName}
//                       </option>
//                     ))}
//                 </select>
//               </div>
            
//               <div className="seq-group full">
              
//                 <label>DESIGNATION</label>

//                 {isGenesisCompany ? (
//                   <select
//                     name="designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">Select Designation...</option>

//                     {genesisDesignations.map((desg) => (
//                       <option key={desg} value={desg}>
//                         {desg}
//                       </option>
//                     ))}
//                   </select>
//                 ) : (
//                   <input
//                     type="text"
//                     name="designation"
//                     placeholder="Enter Designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                     required
//                   />
//                 )}
//               </div>

//               <div className="seq-row">
//                 <div className="seq-group">
//                   <label>CITY</label>
//                   <input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} />
//                 </div>
//                 <div className="seq-group">
//                   <label>COUNTRY</label>
//                   <input type="text" name="country" placeholder="Country" value={formData.country} onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="seq-group full">
//                 <label>MOBILE_NO</label>
//                 <input type="text" name="mobile" placeholder="+XX XXXXX-XXXXX" value={formData.mobile} onChange={handleChange} />
//               </div>

//               <div className="seq-group full">
//                 <button type="submit" className="initialize-btn">
//                   ADD EMPLOYEE
//                   <div className="btn-glow"></div>
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="neural-preview-panel">
//           <div className="radial-status-container">
//             <svg className="radial-svg" viewBox="0 0 100 100">
//               <circle className="bg" cx="50" cy="50" r="45" />
//               <circle
//                 className="meter"
//                 cx="50" cy="50" r="45"
//                 style={{ strokeDashoffset: 282 - (282 * calculateProgress()) / 100 }}
//               />
//             </svg>
//             <div className="radial-info">
//               <span className="percent">{Math.round(calculateProgress())}%</span>
//               <span className="label">SYNCED</span>
//             </div>
//           </div>

//           <div className="glass-id-card">
//             <div className="card-glare"></div>
//             <div className="card-header">
//               <span className="genesis-chip"></span>
//               <span className="card-title">GENESIS_ID</span>
//             </div>
//             <div className="bio-avatar-wrapper">
//               <div className="bio-avatar">
//                 {formData.firstName.charAt(0) || 'G'}
//               </div>
//             </div>
//             <div className="bio-data">
//               <h4>{formData.firstName || 'NEW'} {formData.lastName || 'USER'}</h4>
//               <p className="cyan-text">{formData.department || 'PENDING_SECTOR'}</p>
//               <div className="data-bits">
//                 <div className="bit"><span>UID:</span> {formData.employeeCode || 'AWAITING'}</div>
//                 <div className="bit"><span>ROLE:</span> {formData.role ? formData.role.toUpperCase() : 'PENDING'}</div>
//                 <div className="bit"><span>LOC:</span> {formData.city || 'PENDING'}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddEmployee;
























import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import '../styles/AddEmployee.css'

const initialFormState = {
  employeeCode: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  gender: '',
  department: '',
  designation: '',
  city: '',
  mobile: '',
  birthdate: '',
  joiningDate: '',
  address: '',
  country: '',
  role: ''
};

const AddEmployee = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [successBanner, setSuccessBanner] = useState('');

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [modalEmail, setModalEmail] = useState('');
  const [emailSending, setEmailSending] = useState(false);
  const [createdEmpCredentials, setCreatedEmpCredentials] = useState(null);

  const handleOpenEmailModal = () => {
    setCreatedEmpCredentials(null);
    setModalEmail('');
    setShowEmailModal(true);
  };

  const handleSendEmailSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!modalEmail) {
      alert("Please enter a recipient email address to send credentials.");
      return;
    }

    const credentialsToSend = createdEmpCredentials || formData;

    if (!credentialsToSend.email || !credentialsToSend.password) {
      alert("Please fill in the Employee Email and Password first.");
      return;
    }

    setEmailSending(true);
    try {
      const response = await fetch("/gt-api/send_employee_credentials.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          recipientEmail: modalEmail,
          employeeCode: credentialsToSend.employeeCode,
          firstName: credentialsToSend.firstName,
          lastName: credentialsToSend.lastName,
          loginEmail: credentialsToSend.email,
          password: credentialsToSend.password,
          role: credentialsToSend.role,
          department: credentialsToSend.department,
          designation: credentialsToSend.designation
        }),
      });

      const rawText = await response.text();
      let result;
      try {
        result = JSON.parse(rawText);
      } catch (parseErr) {
        console.error("Server output (not valid JSON):", rawText);
        alert("PHP Server Error: The server returned an invalid response. Raw response:\n" + rawText.substring(0, 300));
        return;
      }

      if (result.success) {
        setSuccessBanner("🎉 Credentials email sent successfully to " + modalEmail + "!");
        setShowEmailModal(false);
      } else {
        alert("Error sending email: " + (result.message || "Failed to send email"));
      }
    } catch (error) {
      console.error("Email sending error:", error);
      alert("Connection Error: Could not reach /gt-api/send_employee_credentials.php\n\nPlease ensure:\n1. XAMPP Apache is running.\n2. The file send_employee_credentials.php exists in C:\\xampp\\htdocs\\gt-api\\");
    } finally {
      setEmailSending(false);
    }
  };

  const [departments, setDepartments] = useState([]);
  const [isGenesisCompany, setIsGenesisCompany] = useState(false);
  const genesisDepartments = [
    "GTE-Human Resource",
    "GTE-Technology Operations",
    "GTE-Accounts",
    "GTE-Admin",
    "FI Design",
    "FSPLO",
    "LTDM PC",
    "DDI",
    "DMS",
    "FI-IE",
    "LTO"
  ];

  const genesisDesignations = [
    "Electrical Design Engineer",
    "Mechanical Design Engineer",
    "Civil/Structural Design Engineer (BIM)",
    "BIM Modeler",
    "Technical Project Coordinator (Power BI)",
    "Project Coordinator",
    "Software Development Engineer",
    "HR Associate",
    "Accountant",
    "Peon"
  ];

  useEffect(() => {
    fetch("/gt-api/get_departments.php", {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        console.log("FULL RESPONSE:", data);
        if (data.success) {
          setDepartments(data.departments || []);
          console.log("TENANT:", data.tenant);

          setIsGenesisCompany(data.tenant === "elmsdb");
        }
      })
      .catch(err => console.error(err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (successBanner) setSuccessBanner('');
  };

  const calculateProgress = () => {
    const filled = Object.values(formData).filter(v => v !== '').length;
    return (filled / 15) * 100;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessBanner('');

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const submitData = {
      empId: formData.employeeCode,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      gender: formData.gender,
      dob: formData.birthdate,
      joiningDate: formData.joiningDate,
      department: formData.department,
      designation: formData.designation,
      mobile: formData.mobile,
      role: formData.role,
      city: formData.city,
      country: formData.country,
      address: formData.address
    };

    try {
      const response = await fetch("/gt-api/add_employee.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(submitData),
      });

      const result = await response.json();
      if (result.success) {
        setCreatedEmpCredentials({
          employeeCode: formData.employeeCode,
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          role: formData.role,
          department: formData.department,
          designation: formData.designation
        });
        setFormData(initialFormState);
        setSuccessBanner("🎉 Employee onboarded successfully!");
        setModalEmail('');
        setShowEmailModal(true);
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("System Offline: Could not reach the PHP server. Check XAMPP.");
    }
  };


  return (
    <div className="genesis-onboarding-hub animate-fade">

      <div className="ambient-glow"></div>

      <div className="hub-layout">
        <div className="interface-panel">
          <div className="panel-header">
            <div className="header-status-indicator">
              <div className="pulse-dot"></div>
              {/* <span>SYSTEM_ACTIVE</span> */}
            </div>
            <h3 className="glitch-text" data-text="Personnel Onboarding">Personnel Onboarding</h3>
          </div>

          {successBanner && (
            <div className="add-emp-success-banner">
              <div className="banner-content">
                <span className="banner-icon">✅</span>
                <span>{successBanner}</span>
              </div>
              <button
                type="button"
                className="banner-close-btn"
                onClick={() => setSuccessBanner('')}
              >
                ✕
              </button>
            </div>
          )}

          <form className="interactive-sequencer" onSubmit={handleSubmit}>
            <div className="sequencer-grid">

              <div className="seq-row">
                <div className="seq-group">
                  <label >EMPLOYEE_ID</label>
                  <input type="text" name="employeeCode" placeholder="GTE-2026-X" value={formData.employeeCode} onChange={handleChange} required />
                </div>
                <div className="seq-group">
                  <label>ASSIGN_ROLE</label>
                  <select name="role" value={formData.role} onChange={handleChange} required>
                    <option value="" disabled hidden>Select Role...</option>
                    <option value="Employee">Employee</option>
                    <option value="Management">Management</option>
                    <option value="Manager">Manager</option>
                  </select>
                </div>
              </div>

              <div className="seq-row">
                <div className="seq-group">
                  <label>FIRST_NAME</label>
                  <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
                </div>
                <div className="seq-group">
                  <label>LAST_NAME</label>
                  <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
                </div>
              </div>

              <div className="seq-group full">
                <label>EMAIL_ADDRESS</label>
                <input type="email" name="email" placeholder="official@genesistech.com" value={formData.email} onChange={handleChange} required />
              </div>

              <div className="seq-row">
                <div className="seq-group">
                  <label>PASSWORD</label>
                  <input type="password" name="password" placeholder="••••••••" value={formData.password} onChange={handleChange} required />
                </div>
                <div className="seq-group">
                  <label>CONFIRM_PASSWORD</label>
                  <input type="password" name="confirmPassword" placeholder="••••••••" value={formData.confirmPassword} onChange={handleChange} required />
                </div>
              </div>

              <div className="seq-row">
                <div className="seq-group">
                  <label>GENDER</label>
                  <select name="gender" value={formData.gender} onChange={handleChange} required>
                    <option value="">Select...</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="seq-group">
                  <label>BIRTH_DATE</label>
                  <div className="add-emp-date-wrapper">
                    <input
                      type="date"
                      name="birthdate"
                      value={formData.birthdate || ""}
                      onChange={handleChange}
                      className="add-emp-date-input"
                    />
                    <button
                      type="button"
                      className="add-emp-calendar-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        const input = e.currentTarget.previousElementSibling;
                        if (input) {
                          try {
                            if (input.showPicker) input.showPicker();
                            else input.focus();
                          } catch (err) {
                            input.focus();
                          }
                        }
                      }}
                      title="Open Calendar"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="seq-group">
                  <label>JOINING_DATE</label>
                  <div className="add-emp-date-wrapper">
                    <input
                      type="date"
                      name="joiningDate"
                      value={formData.joiningDate || ""}
                      onChange={handleChange}
                      required
                      className="add-emp-date-input highlight-input"
                    />
                    <button
                      type="button"
                      className="add-emp-calendar-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        const input = e.currentTarget.previousElementSibling;
                        if (input) {
                          try {
                            if (input.showPicker) input.showPicker();
                            else input.focus();
                          } catch (err) {
                            input.focus();
                          }
                        }
                      }}
                      title="Open Calendar"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div className="seq-group full">
                <label>DEPARTMENT</label>

                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Department...</option>

                  {isGenesisCompany
                    ? genesisDepartments.map((dept) => (
                      <option key={dept} value={dept}>
                        {dept}
                      </option>
                    ))
                    : departments.map((dept) => (
                      <option key={dept.id} value={dept.DepartmentName}>
                        {dept.DepartmentName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="seq-group full">

                <label>DESIGNATION</label>

                {isGenesisCompany ? (
                  <select
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Designation...</option>

                    {genesisDesignations.map((desg) => (
                      <option key={desg} value={desg}>
                        {desg}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    name="designation"
                    placeholder="Enter Designation"
                    value={formData.designation}
                    onChange={handleChange}
                    required
                  />
                )}
              </div>

              <div className="seq-row">
                <div className="seq-group">
                  <label>CITY</label>
                  <input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} />
                </div>
                <div className="seq-group">
                  <label>COUNTRY</label>
                  <input type="text" name="country" placeholder="Country" value={formData.country} onChange={handleChange} />
                </div>
              </div>

              <div className="seq-group full">
                <label>MOBILE_NO</label>
                <input type="text" name="mobile" placeholder="+XX XXXXX-XXXXX" value={formData.mobile} onChange={handleChange} />
              </div>

              <div className="seq-group full">
                <button type="submit" className="initialize-btn">
                  ADD EMPLOYEE
                  <div className="btn-glow"></div>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="neural-preview-panel">
          <div className="radial-status-container">
            <svg className="radial-svg" viewBox="0 0 100 100">
              <circle className="bg" cx="50" cy="50" r="45" />
              <circle
                className="meter"
                cx="50" cy="50" r="45"
                style={{ strokeDashoffset: 282 - (282 * calculateProgress()) / 100 }}
              />
            </svg>
            <div className="radial-info">
              <span className="percent">{Math.round(calculateProgress())}%</span>
              <span className="label">SYNCED</span>
            </div>
          </div>

          <div className="glass-id-card">
            <div className="card-glare"></div>
            <div className="card-header">
              <span className="genesis-chip"></span>
              <span className="card-title">GENESIS_ID</span>
            </div>
            <div className="bio-avatar-wrapper">
              <div className="bio-avatar">
                {formData.firstName.charAt(0) || 'G'}
              </div>
            </div>
            <div className="bio-data">
              <h4>{formData.firstName || 'NEW'} {formData.lastName || 'USER'}</h4>
              <p className="cyan-text">{formData.department || 'PENDING_SECTOR'}</p>
              <div className="data-bits">
                <div className="bit"><span>UID:</span> {formData.employeeCode || 'AWAITING'}</div>
                <div className="bit"><span>ROLE:</span> {formData.role ? formData.role.toUpperCase() : 'PENDING'}</div>
                <div className="bit"><span>LOC:</span> {formData.city || 'PENDING'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showEmailModal && ReactDOM.createPortal(
        <div className="add-emp-modal-overlay" onClick={() => setShowEmailModal(false)}>
          <div className="add-emp-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="add-emp-modal-header">
              <h4>✉️ Onboarding Complete - Send Credentials?</h4>
              <button
                type="button"
                className="add-emp-modal-close"
                onClick={() => setShowEmailModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="add-emp-modal-body">
              <p className="modal-subtext">
                Employee onboarded successfully! Would you like to send their login credentials via email? Enter the target recipient email address below or click <strong>Skip</strong>.
              </p>

              <div className="seq-group full" style={{ marginBottom: '15px' }}>
                <label>RECIPIENT EMAIL ADDRESS</label>
                <input
                  type="email"
                  value={modalEmail}
                  onChange={(e) => setModalEmail(e.target.value)}
                  placeholder="Enter recipient email address..."
                  disabled={emailSending}
                  required
                />
              </div>

              <div className="credentials-preview-box">
                <div className="preview-title">CREDENTIALS PREVIEW</div>
                <div className="preview-row">
                  <span>Login Email:</span>
                  <strong className="cyan-text">{(createdEmpCredentials || formData).email || 'N/A'}</strong>
                </div>
                <div className="preview-row">
                  <span>Password:</span>
                  <strong className="cyan-text">{(createdEmpCredentials || formData).password ? '••••••••' : 'N/A'}</strong>
                </div>
                <div className="preview-row">
                  <span>Website URL:</span>
                  <strong className="cyan-text">gtelinq.com</strong>
                </div>
              </div>
            </div>

            <div className="add-emp-modal-footer">
              <button
                type="button"
                className="modal-cancel-btn"
                onClick={() => setShowEmailModal(false)}
                disabled={emailSending}
              >
                Skip
              </button>
              <button
                type="button"
                className="modal-send-btn"
                onClick={handleSendEmailSubmit}
                disabled={emailSending}
              >
                {emailSending ? (
                  <span className="btn-loader-content">
                    <span className="btn-spinner"></span>
                    Sending Email...
                  </span>
                ) : (
                  "Send Email"
                )}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default AddEmployee;